<template>
	<div class="weiyuan_index">
		<!-- 公共头部 -->
		<div class="per-line-40 black top-box">
			<div class="fl">歡迎來到香港中國企業協會</div>
			<div class="fr">
				<span v-if="$store.state.userName === ''">未登錄</span>
				<span v-else>歡迎 <span class="blue">{{ $store.state.userName }}</span> <span @click="exitAccount()" class="c">退出</span></span>
				<span class="c mar-lef-15" @click="goArticleDetail(2)">關於我們</span>
				<span @click="goArticleDetail(3)" class="mar-lef-15 c">聯系我們</span>
			</div>
		</div>
		<div class="pos-relative" style="height: 272px; ">
			<img src="static/img/banner1.jpg" class="banner-box" height="272" style="opacity: 0.4; ">
			<div class="pos-absolute" style="width: 500px; left: 10%; top: 45px;">
				<img src="static/img/logo.png" class="pos-absolute banner-box-logo width-100per">
			</div>
			<!-- 导航栏 -->
			<div class="per-line-50 red-b pos-absolute font-size-16 white width-100per" style="bottom: 10px;">
				<div style="width: 1200px; margin: 0 auto; " class="over-hidden">
					<div class="fl per-line-50 ellip tl c white" @click="goShopIndex()">首頁</div>
					<mu-menu class="fl per-line-50 tl c over-hidden white" style=" margin-left: 50px;" placement="bottom-start" open-on-hover :key='i' v-for="(category, i) in categorys">
						<div style="background-color: transparent;" class="fl per-line-50 ellip tl c white">{{ category.title }}</div>
						<mu-list slot="content" class="red-b white" :key='j' v-for="(categoryChild, j) in category.child">
							<mu-list-item button @click="goSortIndex(categoryChild.id, categoryChild.title)">
								<mu-list-item-title class="white">{{ categoryChild.title }}</mu-list-item-title>
							</mu-list-item>
						</mu-list>
					</mu-menu>
				</div>
			</div>
		</div>
		<!-- 公共头部 -->
		<div class="over-hidden top-box white-b pad-lef-15 pad-rig-15 pad-bot-15" style="min-height: 600px; ">
			<div class="width-150 fl">
				<div class="per-line-40 white red-b mar-top-15 tc">
					委員會管理
				</div>
				<div class="white-b tc over-hidden">
					<div @click="changeSelect(0)" class="black per-line-40 ellip c gray-b" :class="{'yellow-b-opacity': selectI === 0}">
						委員會信息
					</div>
					<div @click="changeSelect(1)" class="black per-line-40 ellip c gray-b" :class="{'yellow-b-opacity': selectI === 1}">
						文章列表
					</div>
					<div @click="changeSelect(2)" class="black per-line-40 ellip c gray-b" :class="{'yellow-b-opacity': selectI === 2}">
						發布文章
					</div>
				</div>

			</div>
			<!-- 企业信息 -->
			<div v-show="selectI === 0" class="fl width-70per mar-lef-2per mar-top-15">
				<div class="over-hidden white-b tl width-50per mar-lef-25per">
					<form id="imageUploadForm" ref='uploadPictureForm' name="formen">
						<div class="tc height-100 width-100 border-1 fl border-rad-50per c" style="line-height: 100px; background-size: 100% 100%; background-position: center; " onclick="document.formen.myfile.click()" :style="'background-image: url('+ headimgurl +')'">
							<span>{{ uploadMsg }}</span>
						</div>
						<input ref="limiteImage" id="file" class="fr limiteImg" style="height: 30px; width: 300px; text-align: right;" type="file" name="myfile" @change="uploadPicture" accept="image/*" hidden>
					</form>
					<div class="fl height-100 mar-top-15 mar-lef-15">
						<div class="tl">歡迎您, {{ username }}</div>
						<div class="tl">上次登錄: {{ logintime | moment('YYYY-MM-DD HH:mm:ss') }}</div>
						<div class="tl">註冊時間: {{ regtime | moment('YYYY-MM-DD HH:mm:ss') }}</div>
					</div>
				</div>
				<div class="white-b tl pad-15">
					<!-- <div class="per-line-30 ellip mar-top-5">
						<span class="width-30per fl tr ellip">委員會名稱</span>
						<input type="text" v-model="weiyuan_name" placeholder="委員會名稱" class="fl input-style width-48per mar-lef-2per">
					</div>
					<div class="per-line-30 ellip mar-top-5">
						<span class="width-30per fl tr ellip">聯繫人</span>
						<input type="text" v-model="contact_name" placeholder="聯繫人" class="fl input-style width-48per mar-lef-2per">
					</div>
					<div class="per-line-30 ellip mar-top-5">
						<span class="width-30per fl tr ellip">通訊地址</span>
						<input type="text" placeholder="通訊地址" v-model="address" class="fl input-style width-48per mar-lef-2per">
					</div>
					<div class="per-line-30 ellip mar-top-5">
						<span class="width-30per fl tr ellip">網址</span>
						<input type="text" v-model="web_url" class="fl input-style width-48per mar-lef-2per">
					</div>
					<div class="per-line-30 ellip mar-top-5">
						<span class="width-30per fl tr ellip">Tel</span>
						<input type="text" v-model="tel" class="fl input-style width-48per mar-lef-2per">
					</div>
					<div class="per-line-30 ellip mar-top-5">
						<span class="width-30per fl tr ellip">Fax</span>
						<input type="text" v-model="fax" class="fl input-style width-48per mar-lef-2per">
					</div>
					<div class="per-line-30 ellip mar-top-5">
						<span class="width-30per fl tr ellip">E-Mail</span>
						<input type="text" v-model="email" class="fl input-style width-48per mar-lef-2per">
					</div> -->
					<div class="per-line-30 ellip width-100 c" style="margin: 5px auto 0;">
						<div class="per-line-30 tc red-b-opacity white" @click="complete()">修改</div>
					</div>
				</div>
			</div>
			<!-- 文章列表 -->
			<div v-show="selectI === 1" class="white-b fl width-70per mar-lef-2per mar-top-15">
				<div v-for="(articleList, i) in articleLists" class="tl pad-15 font-size-16 over-hidden" :class="{'yellow-b-opacity': i % 2 === 0}">
					<div class="fl mar-top-5">
						<div class="font-size-14">{{ articleList.title }}</div>
						<div class="font-size-14">{{ articleList.showtime | moment('YYYY-MM-DD HH:mm:ss') }}</div>
					</div>
					<div class="fr pos-relative">
						<div>瀏覽: {{ articleList.click_count || '0' }}</div>
						<div @click="goModifyArticle(articleList.id)" class="fl c">修改</div>
						<div @click="removeArticle(articleList.id)" class="fl c mar-lef-15">删除</div>
					</div>
				</div>
			</div>
			<!-- 发布文章 -->
			<div v-show="selectI === 2" class="white-b fl width-70per mar-lef-2per mar-top-15">
				<div class="per-line-30 ellip mar-top-5">
					<span class="fl tl ellip width-100">文章標題</span>
					<input type="text" placeholder="中文" v-model="articleTitle" class="fl input-style width-48per">
				</div>
				<div class="per-line-30 ellip mar-top-5">
					<span class="fl tl ellip width-100">分類</span>
					<span class="fl tl input-style width-100">委員會動態</span>
				</div>
				<div class="per-line-30 ellip mar-top-5">
					<span class="fl tl ellip width-100">簡介</span>
					<input type="text" v-model="summary" class="fl input-style width-48per">
				</div>
				<div class="per-line-30 ellip mar-top-5">
					<span class="fl tl ellip width-100">圖片</span>
					<form id="imageUploadForm" ref='uploadPictureForm2' name="formen2">
						<div class="fl width-100 c per-line-30 border-1" onclick="document.formen2.myfile.click()">上傳</div>
						<input ref="limiteImage" id="file" class="fr limiteImg" style="height: 30px; width: 300px; text-align: right;" type="file" name="myfile" @change="uploadPicture2" accept="image/*" hidden>
					</form>
				</div>
				<div class="tl mar-top-5 mar-bot-5">
					<img class="width-100" v-for="(img, i) in imgs" :src="img.img_thumb">
				</div>
				
				<div class="per-line-30 ellip mar-top-5">
					<span class="fl tl ellip width-100">是否制定</span>
					<select v-model="is_zhiding" class="fl input-style width-100">
						<option value="1">是</option>
						<option value="2">否</option>
					</select>
				</div>
				<div class="ellip mar-top-5">
					<span class="fl tl ellip width-100">詳情</span>
					<!-- <editor id="editor_id" height="500px" width="width-48per" :content="context" pluginsPath="/static/kindeditor/plugins/" :loadStyleMode="false" @on-content-change="onContentChange"></editor> -->
					<textarea v-model="context" id="editor_id" style="width: 500px; height: 500px; "></textarea>
				</div>
				<div @click="publish()" class="fl width-100 c per-line-30 border-1 mar-top-15" style="margin-left: 100px; ">發布</div>
			</div>
			<!-- 文章修改 -->
			<div v-show="showModifyArticle" class="white-b fl width-70per mar-lef-2per mar-top-15">
				<div class="per-line-30 ellip mar-top-5">	
					<span class="fl tl ellip width-100">文章標題</span>
					<input type="text" placeholder="中文" v-model="ma_title" class="fl input-style width-48per">
				</div>
				<div class="per-line-30 ellip mar-top-5">
					<span class="fl tl ellip width-100">分類</span>
					<span class="fl tl input-style width-100">委員會動態</span>
				</div>
				<div class="per-line-30 ellip mar-top-5">
					<span class="fl tl ellip width-100">簡介</span>
					<input type="text" v-model="ma_summary" class="fl input-style width-48per">
				</div>
				<div class="per-line-30 ellip mar-top-5">
					<span class="fl tl ellip width-100">圖片</span>
					<form id="imageUploadForm" ref='uploadPictureForm3' name="formen3">
						<div class="fl width-100 c per-line-30 border-1" onclick="document.formen3.myfile.click()">上傳</div>
						<input ref="limiteImage" id="file" class="fr limiteImg" style="height: 30px; width: 300px; text-align: right;" type="file" name="myfile" @change="uploadPicture3" accept="image/*" hidden>
					</form>
				</div>
				<div class="tl mar-top-5 mar-bot-5">
					<img class="width-100" v-for="(img, i) in ma_imgs" :src="img">
				</div>
				
				<div class="per-line-30 ellip mar-top-5">
					<span class="fl tl ellip width-100">是否制定</span>
					<select v-model="ma_is_zhiding" class="fl input-style width-100">
						<option value="1">是</option>
						<option value="2">否</option>
					</select>
				</div>
				<div class="ellip mar-top-5">
					<span class="fl tl ellip width-100">詳情</span>
					<!-- <textarea v-model="ma_context" class="fl width-48per height-200"></textarea> -->
					<textarea v-model="ma_context" id="editor_id2" style="width: 500px; height: 500px;"></textarea>
				</div>
				<div @click="modifyArticle()" class="fl width-100 c per-line-30 border-1 mar-top-15" style="margin-left: 100px; ">修改</div>
			</div>
		</div>
	</div>
</template>
<script>

export default {
	name: 'weiyuan_index',
	data () {
		return {
			selectI: 0,
			uploadMsg: '上傳圖片',
			headimgurl: '',
			categorys: [],
			type: 2,

			showModifyArticle: false,
			ma_title: '',
			ma_cate_id: '162',
			ma_summary: '',
			ma_context: '',
			ma_is_zhiding: '',
			ma_imgs: [],

			articleLists: [],

			logintime: '',
			regtime: '',
			username: '',

			address: '',
			tel: '',
			fax: '',
			email: '',
			weiyuan_name: '',
			web_url: '',
			contact_name: '',
			imgs: [],

			articleTitle: '',
			cate_id: '162',
			summary: '',
			is_zhiding: 1,
			context: '',
		}
	},
	created () {
		// 文章新增
		let that = this
		$(function (){
			that.kedit('editor_id', that.editor)
		})
	},
	mounted () {
		let that = this
		that.c_ajax({}, 'api.php/CmsCategory/lists', function (value) {
			for (let v of value.data) {
				if (v.id !== 1 && v.id !== 2 && v.id !== 147) {
					that.categorys.push(v)
				}
			}
		})
		// 企业信息
		that.c_ajax({user_id: that.$store.state.user_id }, 'api.php/User/detail', function (value) {
			if (value.data.status === 10001) {
				that.logintime = value.data.detail.logintime
				that.regtime = value.data.detail.regtime
				that.username = value.data.detail.username
				that.headimgurl = value.data.detail.headimgurl
				that.type = value.data.detail.type

				let obj = value.data.detail.weiyuan_info
				that.address = obj.address
				that.tel = obj.tel
				that.fax = obj.fax
				that.email = obj.email
				that.web_url = obj.web_url
				that.weiyuan_name = obj.weiyuan_name
				that.contact_name = obj.contact_name


				if (!that.headimgurl) {
					that.uploadMsg = '上傳圖片'
				} else {
					that.uploadMsg = ''
				}

			} else {
				that.showDialog(value.data.msg)
			}
		})
		that.getArticleLists()
	},
	methods: {
		kedit (Dom, s) {
			let that = this
			s = KindEditor.create('#' + Dom, {
				uploadJson: 'http://203.160.90.202/web/public/static/userweb/tool/kindeditor-4.1.10/php/upload_json.php',
				fileManagerJson: 'http://203.160.90.202/web/public/static/userweb/tool/kindeditor-4.1.10/php/file_manager_json.php',
				allowFileManager: true,
				filterMode: true,
				afterBlur: function () {
					this.sync()
				},
			})
		},
		onContentChange (v) {
			this.context = v
		},
		getArticleLists () {
			let that = this
			that.c_ajax({}, 'api.php/Cms/artlists', function (value) {
				that.articleLists = []
				if (value.data.status === 10001) {
					that.articleLists = []
					for (let v of value.data.lists) {
						that.articleLists.push(v)
					}
				}
			})
		},
		uploadPicture (e) {
			let fd = new FormData(), file = e.target.files[0], that = this
			if (file.size >= 2000*1024) {
				that.showDialog('圖片不能大於2M，請重新上傳')
				that.$refs.uploadPictureForm[0].reset()
				return
			}
			fd.append('myfile', file)
			this.$ajax.post(this.urlPrefix + 'api.php/Plus/upload_img?token=' + this.$store.state.token, fd)
			.then(function (value) {
				if (value.data.status === 10001) {
					that.headimgurl = value.data.img_orogin
					that.uploadMsg = ''
				}
				that.$refs.uploadPictureForm.reset()
			})
		},
		uploadPicture2 (e) {
			let fd = new FormData(), file = e.target.files[0], that = this
			if (file.size >= 2000*1024) {
				that.showDialog('圖片不能大於2M，請重新上傳')
				that.$refs.uploadPictureForm2[0].reset()
				return
			}
			fd.append('myfile', file)
			this.$ajax.post(this.urlPrefix + 'api.php/Plus/upload_img?token=' + this.$store.state.token, fd)
			.then(function (value) {
				if (value.data.status === 10001) {
					that.imgs.push({ img_thumb: value.data.img_orogin })
				}
				that.$refs.uploadPictureForm2.reset()
			})
		},
		uploadPicture3 (e) {
			let fd = new FormData(), file = e.target.files[0], that = this
			if (file.size >= 2000*1024) {
				that.showDialog('圖片不能大於2M，請重新上傳')
				that.$refs.uploadPictureForm3[0].reset()
				return
			}
			fd.append('myfile', file)
			this.$ajax.post(this.urlPrefix + 'api.php/Plus/upload_img?token=' + this.$store.state.token, fd)
			.then(function (value) {
				if (value.data.status === 10001) {
					that.ma_imgs.push(value.data.img_orogin)
				}
				that.$refs.uploadPictureForm3.reset()
			})
		},
		changeSelect (type) {
			this.selectI = type

			if (type === 2) {
				this.articleTitle = ''
				this.summary = ''
				this.context = ''
				this.ma_context = ''
				this.imgs = []
				this.ma_imgs = []
			}
			this.showModifyArticle = false
		},
		complete () {
			let that = this
			// if (!this.weiyuan_name) {
			// 	that.showDialog('委員會名稱不能為空!')
			// 	return
			// }
			// if (!this.contact_name) {
			// 	that.showDialog('聯繫人不能為空!')
			// 	return
			// }
			// if (!this.address) {
			// 	that.showDialog('通訊地址不能為空!')
			// 	return
			// }
			// if (!this.tel) {
			// 	that.showDialog('手機號碼不能為空!')
			// 	return
			// }
			// if (!this.fax) {
			// 	that.showDialog('傳真不能為空!')
			// 	return
			// }
			// if (!this.email) {
			// 	that.showDialog('郵箱不能為空!')
			// 	return
			// }
			// if (!this.web_url) {
			// 	that.showDialog('網址不能為空!')
			// 	return
			// }

			// let post = {
			// 	weiyuan_name: this.weiyuan_name, contact_name: this.contact_name, address: this.address, email: this.email, fax: this.fax, tel: this.tel, web_url: this.web_url, headimgurl: this.headimgurl, type: this.type,
			// }

			let post = {
				headimgurl: this.headimgurl, type: this.type,
			}

			that.c_ajax({post: post}, 'api.php/User/update', function (value) {
				if (value.data.status === 10001) {
					that.showDialog(value.data.msg)
				}
			})
		},
		// 发布文章
		publish () {
			let that = this
			this.context = document.getElementById("editor_id").value
			if (!this.articleTitle) {
				this.showDialog('文章標題不能為空!')
				return
			}
			if (!this.summary) {
				this.showDialog('文章簡介不能為空!')
				return
			}
			if (!this.context) {
				this.showDialog('文章詳情不能為空!')
				return
			}
			let post = {
				title: this.articleTitle,
				cate_id: this.cate_id,
				summary: this.summary,
				is_zhiding: this.is_zhiding,
				context: this.context,
				gallery_thumb: [],
			}
			for (let v of this.imgs) {
				post.gallery_thumb.push(v.img_thumb)
			}
			that.c_ajax({post: post}, 'api.php/Cms/add', function (value) {
				if (value.data.status === 10001) {
					that.showDialog(value.data.msg)
					setTimeout(function () {
						that.selectI = 1
						that.getArticleLists()
					}, 1500)
				} else {
					that.showDialog(value.data.msg)
				}
			})
		},
		// 修改文章
		modifyArticle () {
			let that = this
			this.ma_context = document.getElementById("editor_id2").value
			if (!this.ma_title) {
				this.showDialog('文章標題不能為空!')
				return
			}
			if (!this.ma_summary) {
				this.showDialog('文章簡介不能為空!')
				return
			}
			if (!this.ma_context) {
				this.showDialog('文章詳情不能為空!')
				return
			}

			let post = {
				title: this.ma_title,
				cate_id: this.ma_cate_id,
				summary: this.ma_summary,
				is_zhiding: this.ma_is_zhiding,
				context: this.ma_context,
				gallery_thumb: [],
				id: this.ma_id,
			}
			for (let v of this.ma_imgs) {
				post.gallery_thumb.push(v)
			}
			that.c_ajax({post: post}, 'api.php/Cms/add', function (value) {
				if (value.data.status === 10001) {
					that.showDialog(value.data.msg)
					setTimeout(function () {
						that.selectI = 1
						that.showModifyArticle = false
						that.getArticleLists()
					}, 1500)
				} else {
					that.showDialog(value.data.msg)
				}
			})
		},
		// 删除文章
		removeArticle (article_id) {
			let that = this
			that.c_ajax({id: article_id}, 'api.php/Cms/del', function (value) {
				if (value.data.status === 10001) {
					that.showDialog(value.data.msg)
					setTimeout(function () {
						that.getArticleLists()
					}, 1500)
				}
			})
		},
		// 展示修改文章模块
		goModifyArticle (article_id) {
			let that = this
			this.showModifyArticle = true
			this.selectI = -1
			this.ma_id = article_id
			that.c_ajax({id: article_id}, 'api.php/Cms/detail', function (value) {
				console.log(value)
				if (value.data.status === 10001) {
					let t = value.data.detail
					that.ma_title = t.title
					that.ma_cate_id = t.cate_id
					that.ma_summary = t.summary
					that.ma_context = t.context
					that.ma_is_zhiding = t.is_zhiding || 0
					if (t.image) {
						let tempArr = t.image.split(',')
						for (let v of tempArr) {
							that.ma_imgs.push(v)
						}
					} else {
						that.ma_imgs = []
					}
					$(function (){
						that.kedit('editor_id2', that.editorModify)
					})
				}
			})
		},
	},
}
</script>

<style scoped>
.weiyuan_index {
}
</style>


// WEBPACK FOOTER //
// src/components/weiyuan_index.vue